export const apiAreas = new Set(["farms", "fields", "cropyears", "machines", "fertilizers", "excel", "holos", "analysis", "utilities", "session", "other"]);
export const httpMethods = new Set(["GET", "POST", "PUT", "PATCH", "DELETE", "HEAD", "OPTIONS"]);
export const requestOutcomes = new Set(["succeeded", "failed", "blocked"]);
const uuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const isExpectedValidationResponse = response => response?.status === 422 &&
  response.headers?.["x-ftmc-validation-class"] === "expected" &&
  response.headers?.["x-ftmc-validation-code"] === "domain_validation";

export function apiRequestContext(config, apiBaseUrl, origin = window.location.origin) {
  if (!apiBaseUrl) return null;
  try {
    const base = new URL(apiBaseUrl, origin);
    // Axios joins leading-slash paths to baseURL rather than resolving at origin.
    const url = /^([a-z][a-z\d+.-]*:)?\/\//i.test(config.url || "") ? config.url : `${String(config.baseURL || apiBaseUrl).replace(/\/+$/, "")}/${String(config.url || "").replace(/^\/+/, "")}`;
    const target = new URL(url, origin);
    const basePath = base.pathname.replace(/\/+$/, "");
    if (target.origin !== base.origin || !(target.pathname === basePath || target.pathname.startsWith(`${basePath}/`))) return null;
    const area = target.pathname.slice(basePath.length).split("/").filter(Boolean)[0];
    const method = String(config.method || "GET").toUpperCase();
    return {api_area:apiAreas.has(area) ? area : "other", http_method:httpMethods.has(method) ? method : "GET"};
  } catch { return null; }
}

export function safeRecentRequests(rows) {
  return JSON.stringify((Array.isArray(rows) ? rows : []).slice(-8).map(row => ({
    api_area:apiAreas.has(row?.api_area) ? row.api_area : "other",
    http_method:httpMethods.has(row?.http_method) ? row.http_method : "GET",
    outcome:requestOutcomes.has(row?.outcome) ? row.outcome : "failed",
    request_id:uuid.test(row?.request_id || "") ? row.request_id : "",
  })));
}
